module.exports = __webpack_public_path__ + "static/media/agricultural9.f5cf024b.jpg";